/* eslint-disable no-restricted-globals */
import React from 'react'
import { TableIncrementalStep } from '../../../../../components/common/table'

const CostTable = ({
  data = {},
  onChange,
}) => {
  const handleOnSubmitEditRow = (key, value) => {
    const tmp = [...data.plasticWindowThicknessTypeOperationCost.plasticWindowThicknessCost]
    const tmpValue = value
    if (tmpValue.column1 === null || isNaN(tmpValue.column1)) tmpValue.column1 = 0
    if (tmpValue.column2 === null || isNaN(tmpValue.column2)) tmpValue.column2 = 0
    if (tmpValue.column3 === null || isNaN(tmpValue.column3)) tmpValue.column3 = 0
    if (tmpValue.column4 === null || isNaN(tmpValue.column4)) tmpValue.column4 = 0
    if (tmpValue.column5 === null || isNaN(tmpValue.column5)) tmpValue.column5 = 0
    tmp[key] = tmpValue
    onChange({
      ...data,
      plasticWindowThicknessTypeOperationCost: {
        plasticWindowThicknessCost: tmp,
        plasticWindowThicknessCostColumnName: [...data.plasticWindowThicknessTypeOperationCost.plasticWindowThicknessCostColumnName],
      },
    })
  }

  const handleOnSubmitEditColumn = (value, rows) => {
    const tmpHeaders = value.map((column, i) => {
      let colDataIndex
      if (/column*/.test(column.dataIndex)) {
        colDataIndex = column.dataIndex
      } else if (column.dataIndex !== 'quantity' && column.dataIndex !== 'price') {
        colDataIndex = `column${i}`
      } else {
        colDataIndex = column.dataIndex
      }
      return {
        ...column,
        dataIndex: colDataIndex,
        key: colDataIndex,
      }
    })
    onChange({
      ...data,
      plasticWindowThicknessTypeOperationCost: {
        plasticWindowThicknessCost: rows,
        plasticWindowThicknessCostColumnName: tmpHeaders,
      },
    })
  }

  const handleOnSubmitNewColumn = (value, index) => {
    const tmpHeaders = [...data.plasticWindowThicknessTypeOperationCost.plasticWindowThicknessCostColumnName].map((column, i) => {
      let colDataIndex
      if (/column*/.test(column.dataIndex)) {
        colDataIndex = `column${i}`
      } else {
        colDataIndex = column.dataIndex
      }
      return {
        ...column,
        dataIndex: colDataIndex,
        key: colDataIndex,
      }
    })
    const tmpDatas = [...data.plasticWindowThicknessTypeOperationCost.plasticWindowThicknessCost].map((row, i) => ({
      ...row,
      [index]: 0,
    }))
    tmpHeaders.push({
      title: value,
      dataIndex: index,
      key: index,
      inputType: 'number',
      editable: true,
      editColumn: true,
      alignCell: 'center',
    })
    onChange({
      ...data,
      plasticWindowThicknessTypeOperationCost: {
        plasticWindowThicknessCost: tmpDatas,
        plasticWindowThicknessCostColumnName: tmpHeaders,
      },
    })
  }

  return (
    <TableIncrementalStep
      title="ต้นทุนการติดแผ่นใส"
      onSubmitEditRow={handleOnSubmitEditRow}
      onSubmitEditColumn={handleOnSubmitEditColumn}
      onSubmitNewColumn={handleOnSubmitNewColumn}
      headers={data.plasticWindowThicknessTypeOperationCost.plasticWindowThicknessCostColumnName}
      data={data.plasticWindowThicknessTypeOperationCost.plasticWindowThicknessCost}
      unit={'บาท/ชิ้น'}
    />
  )
}

export default CostTable
